import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Books() {
  const [listBooks, setListBooks] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) navigate('/login');

    axios
      .get('/books', {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((response) => {
        setListBooks(response.data.listBooks);
      });
  }, []);

  return (
    <div>
      <h1>Books</h1>
      <div className="row mb-3">
        <div className="col d-flex justify-content-start">
          <Link to="/creatbooks" className="btn btn-warning ">
            Nouveau Livre
          </Link>
          <Link to="/listcategorie" className="btn btn-warning ">
            Categorie
          </Link>
        </div>
      </div>
      <div>
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Titre</th>
              <th>Nombre de page</th>
              <th>Categorie</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {listBooks.map((book, key) => {
              return (
                <tr key={key}>
                  <td> {book.titre} </td>
                  <td> {book.page} </td>
                  <td> </td>
                  <td>
                    <i className="fa fa-edit"></i>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Books;
